document.addEventListener('DOMContentLoaded', () => {
  const revealItems = document.querySelectorAll('.vps-reveal');

  if (revealItems.length && !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else if (revealItems.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.18,
      }
    );

    revealItems.forEach((item) => observer.observe(item));
  }

  document.querySelectorAll('.vps-pro__stepper').forEach((stepper) => {
    const input = stepper.querySelector('input');
    const minus = stepper.querySelector('[data-vps-qty-minus]');
    const plus = stepper.querySelector('[data-vps-qty-plus]');

    if (!input || !minus || !plus) {
      return;
    }

    minus.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('.vps-pro__cards, .vps-pro__finish-grid').forEach((group) => {
    group.addEventListener('change', (event) => {
      const input = event.target;

      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') {
        return;
      }

      group.querySelectorAll('.vps-pro__choice, .vps-pro__finish').forEach((choice) => {
        choice.classList.toggle('is-selected', choice.contains(input));
      });
    });
  });

  document.querySelectorAll('.vps-pro').forEach((productSection) => {
    const variantSelect = productSection.querySelector('[data-vps-variant-select]');
    const variantButtons = productSection.querySelectorAll('[data-vps-variant-button]');
    const mediaItems = productSection.querySelectorAll('[data-vps-product-media]');
    const fallbackMedia = productSection.querySelectorAll('[data-vps-gallery-fallback]');
    const priceTargets = productSection.querySelectorAll('[data-vps-dynamic-price]');
    const priceBlock = productSection.querySelector('.vps-pro__price');
    const addButton = productSection.querySelector('.vps-pro__add');

    const withCurrencyCode = (value) => {
      return String(value || '').replace(/\s+/g, ' ').trim();
    };

    const normalizePriceLabels = () => {
      priceTargets.forEach((target) => {
        target.textContent = withCurrencyCode(target.textContent);
      });

      if (!priceBlock) {
        return;
      }

      Array.from(priceBlock.childNodes).forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = withCurrencyCode(node.textContent);
        }
      });

      priceBlock.querySelectorAll('s').forEach((comparePrice) => {
        comparePrice.textContent = withCurrencyCode(comparePrice.textContent);
      });
    };

    normalizePriceLabels();

    const syncFallbackMedia = (visibleRealMedia, heroMedia) => {
      if (!fallbackMedia.length) {
        return;
      }

      const visibleMedia = visibleRealMedia || Array.from(mediaItems).filter((media) => !media.classList.contains('is-hidden'));
      const hero = heroMedia || visibleMedia.find((media) => media.classList.contains('vps-pro__media--hero')) || visibleMedia[0];
      const supportCount = visibleMedia.filter((media) => media !== hero).length;
      const minimumSupportCount = 2;
      const pairedSupportCount = supportCount % 2 === 0 ? supportCount : supportCount + 1;
      const targetSupportCount = Math.max(minimumSupportCount, pairedSupportCount);
      const neededCount = Math.max(0, targetSupportCount - supportCount);

      fallbackMedia.forEach((media, index) => {
        media.classList.toggle('is-hidden', index >= neededCount);
      });
    };

    if (!variantSelect || !variantButtons.length) {
      syncFallbackMedia();
      return;
    }

    const normalize = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

    const getOption = () => {
      const option = variantSelect.selectedOptions[0];
      return option?.dataset.vpsOption1 || option?.dataset.vpsVariantTitle || option?.textContent || '';
    };

    const updateMedia = () => {
      if (!mediaItems.length) {
        return;
      }

      const selectedFeaturedMediaId = variantSelect.selectedOptions[0]?.dataset.vpsFeaturedMediaId || '';
      const selectedOption = normalize(getOption());
      const tokens = selectedOption.split(' ').filter(Boolean);
      const matchedMedia = new Set();

      mediaItems.forEach((media) => {
        if (selectedFeaturedMediaId && media.dataset.vpsMediaId === selectedFeaturedMediaId) {
          matchedMedia.add(media);
          return;
        }

        const alt = normalize(media.dataset.vpsMediaAlt);
        if (tokens.length && tokens.some((token) => alt.includes(token))) {
          matchedMedia.add(media);
        }
      });

      const hasMatches = matchedMedia.size > 0;

      mediaItems.forEach((media) => {
        media.classList.toggle('is-hidden', hasMatches && !matchedMedia.has(media));
        media.classList.remove('vps-pro__media--hero', 'is-vps-selected-media');
      });

      const selectedMedia = selectedFeaturedMediaId
        ? Array.from(mediaItems).find((media) => media.dataset.vpsMediaId === selectedFeaturedMediaId)
        : null;
      const visibleMedia = Array.from(mediaItems).filter((media) => !media.classList.contains('is-hidden'));
      const heroMedia = selectedMedia && !selectedMedia.classList.contains('is-hidden') ? selectedMedia : visibleMedia[0];

      heroMedia?.classList.add('vps-pro__media--hero', 'is-vps-selected-media');
      syncFallbackMedia(visibleMedia, heroMedia);
    };

    const updateVariantUi = () => {
      const option = variantSelect.selectedOptions[0];
      const selectedId = variantSelect.value;
      const price = withCurrencyCode(option?.dataset.vpsPrice || '');
      const comparePrice = withCurrencyCode(option?.dataset.vpsComparePrice || '');
      const available = option?.dataset.vpsAvailable !== 'false';

      variantButtons.forEach((button) => {
        button.classList.toggle('is-selected', button.dataset.vpsVariantId === selectedId);
      });

      priceTargets.forEach((target) => {
        target.textContent = price;
      });

      if (priceBlock && price) {
        priceBlock.innerHTML = comparePrice ? `${price} <s>${comparePrice}</s>` : price;
      }

      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? 'Add to cart' : 'Sold out';
      }

      updateMedia();
    };

    variantButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) {
          return;
        }

        variantSelect.value = button.dataset.vpsVariantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    variantSelect.addEventListener('change', updateVariantUi);
    updateVariantUi();
  });

  document.querySelectorAll('[data-vps-track-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();

      const field = form.querySelector('input[name="tracking_number"]');
      const trackingNumber = field ? field.value.trim() : '';
      const url = trackingNumber
        ? `https://www.17track.net/en/track?nums=${encodeURIComponent(trackingNumber)}`
        : 'https://www.17track.net/en';

      window.open(url, '_blank', 'noopener,noreferrer');
    });
  });
});
